import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { Add_Price_Api } from '../../API/PriceApi'; // فرض شده است
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// -----------------------------------------------------------
// جایگزین کردن DatePickerJalali با react-multi-date-picker و آداپتور
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-"); 
};

// =================================================================
/**
 * آداپتور سفارشی برای اتصال react-multi-date-picker به Form.Item آنت‌دیزاین.
 * خروجی همیشه YYYY-MM-DD با ارقام انگلیسی است.
 */
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    useEffect(() => {
        // این کار مقدار اولیه (اگر از بیرون تنظیم شده باشد) را به DatePicker می‌دهد
        setDateValue(toDateObject(value));
    }, [value]);

    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            // خروجی گرفتن با فرمت YYYY-MM-DD
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);
            // تبدیل ارقام فارسی به انگلیسی در لحظه خروج
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} 
        />
    );
};
// =================================================================

export const AddPriceComponent = ({ setLoading, showMessage, categoryId, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm()
    
    // State های fromDate و toDate دیگر نیاز نیستند، زیرا آداپتور، مقدار نهایی را مستقیماً به Form.Item می‌دهد
    // اما برای سادگی و همخوانی با ساختار قبلی شما، می‌توانیم از from_Shamsi و to_Shamsi در Form.Item استفاده کنیم.
    // اگرچه از آنها استفاده نمی‌کنیم، اما بهتر است حذف نشوند تا خطایی در Form.Item رخ ندهد.
    
    // =================================================================
    useEffect(() => {
        form.setFieldsValue({ isActive: true });
    }, []);
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            // مقادیر from_Shamsi و to_Shamsi توسط آداپتور به صورت YYYY-MM-DD انگلیسی تنظیم شده‌اند.
            const updatedValues = {
                ...values,
                categoryId: categoryId,
                // from_Shamsi و to_Shamsi مستقیماً از values گرفته می‌شوند
            };

            let data = await Add_Price_Api(updatedValues);
            
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowInserted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        // !!! رفع مشکل رندر آبجکت خطا
        const errorFields = errorInfo.errorFields;
        let errorMessage = "خطا در تکمیل فرم. فیلدهای زیر مشکل دارند: \n";
        
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(field => {
                const fieldName = field.name.join(' '); 
                const fieldErrors = field.errors.join(' | '); 
                errorMessage += `\n ${fieldName}: ${fieldErrors}`;
            });
        } else {
             errorMessage = "خطا در تکمیل فرم: " + JSON.stringify(errorInfo);
        }

        showMessage(errorMessage, "error");
    };
    // =================================================================
    
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    ایجاد قیمت گذاری جدید
                </h2>
            </div>
            <div className='container'>

                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 21 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item name="id" hidden={true} />
                    
                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>

                    {/* جایگزین DatePickerJalali با PersianDatePickerAdapter */}
                    <Form.Item
                        name="from_Shamsi"
                        label="از تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                    >
                        {/* value و onChange توسط Form.Item به صورت خودکار فراهم می‌شوند */}
                        <PersianDatePickerAdapter />
                    </Form.Item>

                    <Form.Item
                        name="to_Shamsi"
                        label="تا تاریخ"
                        rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                    >
                        {/* value و onChange توسط Form.Item به صورت خودکار فراهم می‌شوند */}
                        <PersianDatePickerAdapter />
                    </Form.Item>

                    <Form.Item
                        name="categoryId"
                        hidden={true}
                        // مقدار categoryId توسط prop از کامپوننت والد دریافت و در onSubmit استفاده می‌شود
                    />
                    
                    <Form.Item
                        label="هزینه ثابت"
                        name="fix"
                        rules={[{ required: true, message: 'لطفاً هزینه ثابت را وارد کنید!' }]}
                    >
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                    
                    <Form.Item
                        label="هزینه هر نفر"
                        name="perPerson"
                        rules={[{ required: true, message: 'لطفاً هزینه هر نفر را وارد کنید!' }]}
                    >
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                    
                    <Form.Item
                        label="هزینه نفر اضافی"
                        name="extraPerson"
                    >
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>

                    <Form.Item
                        label="هزینه کودک"
                        name="perChild"
                    >
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>

                    <Form.Item
                        name="orderIndex"
                        label="ترتیب"
                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        name="isActive"
                        label="فعال"
                        valuePropName='checked'
                    >
                        <Checkbox ></Checkbox>
                    </Form.Item>
                </Form>
            </div>

            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <RollbackOutlined />
                        لغو </Button>
                </Col>
            </Row>


        </>
    )
}